export const SITE_EMBED_SOURCES = ['site_login', 'site_mcp_signup'];

export default source => SITE_EMBED_SOURCES.includes(source);
